import { useState } from 'react';
import { Box, Link, Typography } from '@mui/material';
import type { ReviewReason } from '../../lib/employerReview/reviewReason.types';
import { ReviewReasonList } from './ReviewReasonCard';

export function AdditionalFindings({ reasons }: { reasons: ReviewReason[] }) {
  const [open, setOpen] = useState(false);
  if (!reasons.length) return null;

  const label =
    reasons.length === 1 ? 'View 1 additional finding' : `View ${reasons.length} additional findings`;

  return (
    <Box>
      <Link
        component="button"
        type="button"
        variant="body2"
        underline="hover"
        onClick={() => setOpen((v) => !v)}
        sx={{ fontWeight: 600, color: 'text.secondary', fontSize: '0.8125rem' }}
      >
        {open ? 'Hide additional findings' : label}
      </Link>
      {open ? (
        <Box sx={{ mt: 0.85 }}>
          <ReviewReasonList reasons={reasons} />
        </Box>
      ) : null}
    </Box>
  );
}

export function RecommendedAction({ action }: { action: string | null }) {
  if (!action?.trim()) return null;
  return (
    <Box sx={{ pt: 0.25 }}>
      <Typography
        variant="caption"
        color="text.secondary"
        sx={{ fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.45, display: 'block', mb: 0.35 }}
      >
        Recommended next step
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.45, fontSize: '0.875rem' }}>
        {action}
      </Typography>
    </Box>
  );
}

export function ViewDetailsLink({
  onClick,
  label = 'View verification details',
}: {
  onClick: () => void;
  label?: string;
}) {
  return (
    <Link
      component="button"
      type="button"
      variant="body2"
      underline="hover"
      onClick={onClick}
      sx={(theme) => ({
        fontWeight: 600,
        fontSize: '0.8125rem',
        alignSelf: 'flex-start',
        color: theme.palette.mode === 'light' ? '#0E7490' : '#5EEAD4',
        '&:hover': {
          color: theme.palette.mode === 'light' ? '#0891B2' : '#99F6E4',
        },
      })}
    >
      {label}
    </Link>
  );
}
